import NativeFlex from 'components/NativePost/Bits/NativeFlex';
import styled, { css } from 'components/_UI/designSystem';

export const StyledMedia = styled(NativeFlex)<{ percentage: number }>`
    position: relative;
    overflow: hidden;
    border-radius: 12px;

    .video-js {
        height: 100%;
        width: 100%;
    }
    ${({ percentage }) =>
        percentage &&
        css`
            padding-top: ${percentage}%;
            max-height: 0;
        `};
`;

export const StyledImage = styled(NativeFlex)<{ enrichment: any; url: string }>`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    ${({ url }) =>
        url &&
        css`
        background-image: url('${url}');
    `};
`;
